import React from "react";
import {BoxHeader} from "../grouping/BoxHeader";
import {BackToOverviewButton} from "../navigation/NavigationButtons";
import styled from "styled-components";
import GroupingSelector from "./GroupingSelector";
import {formatGroupName} from "../grouping/GroupingTranslator";
import SearchBox from "./SearchBox";
import GroupingExportButton from "../GroupingExportButton";


export const ExploreControls = ({firstGroupingName, secondGroupingName, isLoading, onBackToOverviewClick, onExportClick, onExportDisabledClick, onSecondaryGrouping, showSecondaryOptions, applyFilter, exportUrl, ourProgrammeContext}) => {
    const formattedFirstGroupingName = formatGroupName(firstGroupingName);
    const secondGroupingComponent = !showSecondaryOptions ? null
                                                          : <GroupingSelector firstGroupingName={firstGroupingName}
                                                                              selectedGroupingName={secondGroupingName}
                                                                              isLoading={isLoading}
                                                                              onSelect={onSecondaryGrouping}/>;


    const disableExportButton = (secondGroupingName && 0 !== secondGroupingName.length);
    return (
        <BoxHeader>
            <HeadingContainer>
            <GroupingName>View by {formattedFirstGroupingName}</GroupingName>
            {secondGroupingComponent}
            <SearchBox ourProgrammeContext={ourProgrammeContext}
                       applyFilter={applyFilter}/>
            </HeadingContainer>
            <GroupingExportButton
                exportUrl={exportUrl}
                onExportClick={onExportClick}
                onExportDisabledClick={onExportDisabledClick}
                disableExportButton={disableExportButton}
                addBoxShadow={true}
                buttonRightMargin={"16px"}
                imagePadding={"4px"}
                imageWidth={"23px"}
                imageHeight={"23px"}
            />
            <BackToOverviewButton onClick={onBackToOverviewClick}/>
        </BoxHeader>
    );
};

const HeadingContainer = styled.div`
    display: flex;
`;


export const GroupingName = styled.div`
    font-weight: bold;
    margin-right: 30px;
`;